import moment from 'moment';
const map = new Map();
map.set('minute', 'minutos');
map.set('word', 'palavras');
map.set('page', 'páginas');
const formatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRA',
});
// Reference: https://gist.github.com/paulredmond/871f8eba7ae5d1eb3bc020dd9391ce17
export default {
  methods: {
    transliterateServiceMetric(metric) {
      try {
        return map.get(metric) || metric;
      } catch (error) {
        console.error(error.message);
      }
      return metric;
    },
    findPlanByName(plans, plan, field) {
      const plansParsed = JSON.parse(JSON.stringify(plans));
      const p = plansParsed.find(p => p.name === plan);
      return p && p[field] ? p[field] : '---';
    },
    maxInstallment(value) {
      if (value > 1) {
        return `em até ${value} vezes`;
      }
      return `em até ${value} vez`;
    },
    getPlanColor(plan) {
      const map = new Map();
      map.set('instant', '#F15A22');
      map.set('express', '#EFC100');
      map.set('fast', '#76B301');
      map.set('flex', '#00B0D8');
      return map.get(plan);
    },
    translateMetric(metric, amount) {
      switch (metric) {
        case 'minute':
          return amount === 1 ? `${amount} minuto` : `${amount} minutos`;
        case 'word':
          return amount === 1 ? `${amount} palavra` : `${amount} palavras`;
        case 'page':
          return amount === 1 ? `${amount} página` : `${amount} páginas`;
        default:
          return amount === 1 ? `${amount} minuto` : `${amount} minutos`;
      }
    },
    dateSinceCreation(date) {
      return new Date(date).toElapsedString();
    },
    formatDate(date) {
      if (date) {
        return moment(String(date)).format('MM/DD/YYYY hh:mm')
      }
    },
    formatMoney(money) {
      return formatter.format(money).replace('BRA', 'R$');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/service.js